import React, { useState, useEffect } from 'react';
import { TFunction, withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Swal, { SweetAlertResult } from 'sweetalert2';
import { ReactComponent as LogoSVG } from "../../node_modules/itd-common/assets/images/brand/logo.svg";
import { UserService } from "../services/UserService";
import "./ForgotPassword.scss";
import LabelMessage from './LabelMessage';
import Form from './containers/form';
import SubmitButton from './controls/buttons/submitButton';
import EmailField from './controls/fields/emailField';
import Footer from './layout/Footer';
import CustomReCAPTCHA from "./CustomCaptcha";
import {AxiosError} from "axios";
import { ReactComponent as SendMail } from "../../node_modules/itd-common/assets/images/onboarding/illus_email.svg";
import { UtilService } from '../services/UtilService';
import BrandLogo from '../components/layout/auth/authLogoModal';

interface IProps { 
    t: TFunction
}

let ForgotPassword: React.FC<IProps> = ({ t }) => {
    const T_PREFIX: string = 'pages.forgotKey.';
    const [model, setModel] = useState({ email: '' });
    const [isValid, setIsValid] = useState(true);
    const [isEmpty, setIsEmpty] = useState(false);
    const [emailSent, setEmailSent] = useState(false);
    const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
    const [token, setToken] = useState("");
    const [bgImage, setBgImage] = useState("/bgmerchantcenter.jpg");
    
    useEffect(() => {
        const updateBg = () => {
            setBgImage(window.innerWidth <= 425 ? "/bgmerchantcentermobile.jpg" : "/bgmerchantcenter.jpg");
        };
        updateBg();
        window.addEventListener("resize", updateBg);
        return () => window.removeEventListener("resize", updateBg);
    }, []);
    
    const validateEmail = (emailValue: string): boolean => {
        const emailRegex: RegExp = /\S+@\S+\.\S+/;     
        return emailRegex.test(emailValue);
    };
    const updateValues = (emailValue: string): void => {
        setIsValid(!emailValue || validateEmail(emailValue));
        setIsEmpty(!emailValue || emailValue.length === 0);
    }
    const handleCaptchaVerify = (onVerify: boolean,token:string) => {
        setToken(token);
        setIsCaptchaVerified(onVerify);
    };
    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const email: string = event.target.value;
        setModel({ email });
        updateValues(email);
    };
    const sendEmail = (): void => {
        const email: string = model.email;
        if (validateEmail(email) && isCaptchaVerified) {
            const swalFire = (titleKey: string, htmlKey: string): Promise<SweetAlertResult<Awaited<null>>> => {
                return Swal.fire({
                    icon: "info",
                    title: `${t(`${T_PREFIX}sendMailModal.${titleKey}`)}`,
                    html: t(`${T_PREFIX}sendMailModal.${htmlKey}`),
                    confirmButtonColor: '#f60'
                });
            };
            UserService.sendEmailToRecoverPass(email,token).then((response) => {
                if (response.status !== 200) {
                    swalFire('errorTitle', 'contactHelpDesk');
                } else {
                    setEmailSent(true);
                }
            }).catch((e:AxiosError) => {
                if(e.response?.data == "sendMailToManyTimes"){
                    swalFire('errorTitleManyTimes', 'sendMailToManyTimes');
                }else if(e.response?.data == "captcha.validation.fails"){
                    swalFire('errorTitleManyTimes', 'captchaValidationFails');
                }else if(e.response?.status === 400){
                    setEmailSent(true);
                }else
                    swalFire('errorTitle', 'contactHelpDesk');
            });
        } else {
            updateValues(email);
        }
    };
    const MailKey: React.FC= () => {        
        return (
            <React.Fragment>
            <div className="page forgot-key" style={{ backgroundImage: `url(${bgImage})`}}>
                    <div className="container-login100" >
                            <div className="wrap-login100 p-6">
                                <div className='brand-logo-container mb-3'>
                                    <LogoSVG className='brand-logo-container__image'></LogoSVG>
                                    <div className='divider'></div>
                                    <h4>{t(`common.merchantCenter`)}</h4>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <SendMail className='py-1 px-3 ' />
                                    </div>
                                    <div className="col-md-12 my-2">
                                        <h6 className='fw-bold text-center'>{t(`${T_PREFIX}sendMail.title`)}</h6>
                                        <small className='d-block text-center'>{t(`${T_PREFIX}sendMail.description`)}</small>
                                    </div>
                                        <div className="col-md-12 d-flex justify-content-center ">
                                            <Link to={'/help-outside'} className="linkTo">
                                                {t(`${T_PREFIX}needHelp`)}
                                            </Link>
                                        </div>
                                </div>
                            </div>
                        </div>
                </div>
            </React.Fragment>
        )
    }

return (
    <React.Fragment>
        {emailSent ? (
            <MailKey />
        ) : (
            <div className="page forgot-key" style={{ backgroundImage: `url(${bgImage})`}}>
                <div className=""> 
                    <div className="container-forgot" >
                        <div className="form">
                            <BrandLogo />
                            <div className="backward">
                            <div className="backward__init">
                                <Link to={'/login'} className="link">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g id="ico/arrow-left">
                                            <path id="Vector 1" d="M10 4L2 12L10 20" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <line id="Line 7" x1="3" y1="12" x2="21" y2="12" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </g>
                                    </svg>            
                                    <span className='backward__init__callback'>{t(`${T_PREFIX}returnToLogin`)}</span>
                                </Link>
                            </div>
                            </div>
                            <span className="login100-form-title pb-4">
                                {t(`${T_PREFIX}title`)}
                            </span>
                            <p>{t(`${T_PREFIX}description`)}</p>
                            <Form model={[model, setModel]} onSubmit={sendEmail}>
                                <div>
                                    <div className="login100-form validate-form">
                                        <div>
                                            <p>{t(`${T_PREFIX}email`)}</p>
                                        <EmailField attr="email" label={`${T_PREFIX}username`} onChange={handleOnChange} required autoFocus></EmailField>
                                        </div>                           
                                        <LabelMessage valid={isValid} message={t(`${T_PREFIX}invalidEmail`)} ></LabelMessage>
                                        <LabelMessage valid={!isEmpty} message={t(`${T_PREFIX}emptyEmail`)} ></LabelMessage>
                                    </div>
                                    <div className='confirmForgotPass row' >
                                        <div className="col-md-12">                                
                                            <CustomReCAPTCHA useCache={false} onVerify={handleCaptchaVerify} />
                                        </div> 
                                    </div>
                                    <div>
                                        <div className="boton col-md-12">
                                            <div className="boton__click">
                                                <SubmitButton className="mb-4 envio">
                                                    <div className='submit-button-container'>
                                                        <span className='ms-3' >{t(`${T_PREFIX}continue`)}</span>
                                                    </div>
                                                </SubmitButton>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12 d-flex justify-content-center ">
                                            <Link to={'/help-outside'} className="linkTo">
                                                {t(`${T_PREFIX}needHelp`)}
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </Form>                          
                        </div>
                    </div>
                </div>
            </div>
        )}
        <Footer isValid={false} />
    </React.Fragment>     
);
}
export default withTranslation()(ForgotPassword);